import { cn } from "@/lib/utils";

function Skeleton({
  role = "status",
  "aria-label": ariaLabel = "Loading",
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>): JSX.Element {
  return (
    <div
      aria-label={ariaLabel}
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      role={role}
      {...props}
    />
  );
}

export { Skeleton };
